"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attach = exports.isCacheable = exports["default"] = exports.Feature = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _helper = _interopRequireDefault(require("./helper.js"));

var isFunction = function isFunction(o) {
  return typeof o === 'function';
};
/**
 * @typedef {import("./runtime").Runtime} Runtime
 */

/**
 * @typedef {import("./utils.properties").Mixin} Mixin
 */

/**
 * @typedef {import("./utils.properties").MixinOptions} MixinOptions
 */

/**
 * @class Feature
 * @extends Helper
 * @classdesc The Feature Class is used to provide an interface to something which can be
 * enaabled() and optionally configured() and possibly even have persistent state
 * throughout their object lifecyle.  Extended runtimes such as @skypager/node
 * are just a normal runtime which packages certain node specific features
 * and enable them automatically.
 */

/**
 * The options this feature was created with, combined with the options it was enabled with.
 * @name featureSettings
 * @type {Object}
 * @memberof Feature#
 */


var Feature =
/*#__PURE__*/
function (_Helper) {
  (0, _inherits2["default"])(Feature, _Helper);

  function Feature() {
    (0, _classCallCheck2["default"])(this, Feature);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Feature).apply(this, arguments));
  }

  (0, _createClass2["default"])(Feature, [{
    key: "afterInitialize",

    /**
     * @private
     */
    value: function afterInitialize() {
      this.applyInterface(this.featureMixin, this.featureMixinOptions);
    }
    /**
     * A Feature helper can define a featureMixinOptions or mixinOptions property
     * which is used to control the behavior of the interface that gets built for the feature.
     * This is based on @skypager/runtime/src/utils/properties applyInterface method, which takes
     * an object of functions and binds it to the target object, which in this case is the feature instance,
     * and automatically appends the runtime context as the last argument to every function.
     *
     * This is only useful for module of function style feature helpers, and is not needed so much
     * for class based Features.
     *
     * @readonly
     * @memberof Feature
     */

  }, {
    key: "enable",

    /**
     * Enable the feature.
     *
     * @param {Object} options options to enable this feature with
     * @param {Function} [callback] a callback that will get called when the feature is finished enabling.
     * @returns {PromiseLike<Feature>}
     */
    value: function enable() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var runtime = this.runtime;
      var _this$lodash = this.lodash,
          identity = _this$lodash.identity,
          isFunction = _this$lodash.isFunction,
          defaultsDeep = _this$lodash.defaultsDeep;

      if (isFunction(options)) {
        callback = options;
        options = {};
      }

      if (!isFunction(callback)) {
        callback = identity;
      }

      if (runtime.isFeatureEnabled(this.name) && runtime.get("enabledFeatures.".concat(this.name, ".cacheKey")) === this.cacheKey) {
        // this.runtime.debug(`Attempting to enable ${this.name} after it has already been enabled.`)
        callback(null, this);
        return this;
      }

      try {
        this.hide('featureSettings', defaultsDeep({}, options, this.options), {
          configurable: true
        });
      } catch (error) {}

      try {
        this.host.applyInterface(this.hostMixin, this.hostMixinOptions);
      } catch (error) {
        console.error('error applying host mixin', error);
        this.hostMixinError = error;
      }

      var hook = function hook() {
        return (// this handles the class style
          _this.featureWasEnabled ? Promise.resolve(_this.featureWasEnabled(options)) : // this handles the module style
          _this.attemptMethodAsync('featureWasEnabled', options)
        );
      };

      return hook().then(function () {
        _this.runtime.featureStatus.set(_this.name, {
          cacheKey: _this.cacheKey,
          status: 'enabled',
          cfg: options,
          options: _this.options
        });

        callback(null, _this);
        return _this;
      })["catch"](function (error) {
        _this.runtime.featureStatus.set(_this.name, {
          status: 'failed',
          error: error,
          cacheKey: _this.cacheKey,
          cfg: options,
          options: _this.options
        });

        _this.runtime.error("Error while enabling feature", _this, error.message);

        callback(error);
        throw error;
      });
    }
  }, {
    key: "runMethod",
    value: function runMethod(methodName) {
      var method = this.tryGet(methodName, this.get(methodName));

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return isFunction(method) && method.call.apply(method, [this].concat((0, _toConsumableArray2["default"])(args.push(this.context))));
    }
  }, {
    key: "featureMixinOptions",
    get: function get() {
      var defaults = this.lodash.defaults;
      var opts = this.tryResult('featureMixinOptions') || this.tryResult('mixinOptions') || {};
      return defaults({}, opts, this.defaultMixinOptions);
    }
    /**
     * A Feature Helper which defines a runtime or host mixin will extend the runtime with
     * the specified functions / properties.  The hostMixinOptions controls the binding, and argument
     * signature of these functions, similar to featureMixinOptions
     *
     * @readonly
     * @memberof Feature
     */

  }, {
    key: "hostMixinOptions",
    get: function get() {
      var defaults = this.lodash.defaults;
      var opts = this.tryResult('hostMixinOptions') || this.tryResult('mixinOptions') || {};
      return defaults({}, {
        scope: this.host
      }, opts, this.defaultMixinOptions);
    }
    /**
     * The default mixin options that will be used when the feature doesn't declare its own.
     * These will be passed to the applyInterface calls for both feature and host mixins.
     *
     * @type {MixinOptions}
     * @readonly
     * @memberof Feature
     */

  }, {
    key: "defaultMixinOptions",
    get: function get() {
      return {
        transformKeys: true,
        scope: this,
        partial: [this.context],
        insertOptions: true,
        right: true,
        hidden: false,
        configurable: true
      };
    }
  }, {
    key: "hostMixin",
    get: function get() {
      return this.projectMixin;
    }
  }, {
    key: "projectMixin",
    get: function get() {
      var _this2 = this;

      return this.chain.get('hostMethods').filter(function (m) {
        return isFunction(_this2.tryGet(m));
      }).keyBy(function (m) {
        return m;
      }).mapValues(function (m) {
        return _this2.tryGet(m);
      }).pickBy(function (v) {
        return isFunction(v);
      }).value();
    }
  }, {
    key: "featureMixin",
    get: function get() {
      var _this3 = this;

      var hostMethods = this.hostMethods;
      return this.chain.get('featureMethods').filter(function (m) {
        return hostMethods.indexOf(m) === -1 && isFunction(_this3.tryGet(m));
      }).keyBy(function (m) {
        return m;
      }).mapValues(function (m) {
        return _this3.tryGet(m);
      }).pickBy(function (v) {
        return isFunction(v);
      }).value();
    }
  }, {
    key: "featureMethods",
    get: function get() {
      return this.tryResult('featureMethods', []);
    }
  }, {
    key: "runtimeMethods",
    get: function get() {
      var _this$lodash2 = this.lodash,
          uniq = _this$lodash2.uniq,
          flatten = _this$lodash2.flatten; // need to consolidate on one name

      var hostMethods = this.tryGet('hostMethods', []);
      var runtimeMethods = this.tryGet('runtimeMethods', []);
      var projectMethods = this.tryGet('projectMethods', []);
      return uniq(flatten(hostMethods, runtimeMethods, projectMethods));
    }
  }, {
    key: "hostMethods",
    get: function get() {
      return this.runtimeMethods;
    }
  }, {
    key: "projectMethods",
    get: function get() {
      return this.runtimeMethods;
    }
  }, {
    key: "dependencies",
    get: function get() {
      return this.tryGet('dependencies', {});
    }
  }, {
    key: "isSupported",
    get: function get() {
      return this.tryResult('isSupported', true);
    }
  }, {
    key: "projectConfigKeys",
    get: function get() {
      var uniq = this.lodash.uniq;
      var _this$runtime$stringU = this.runtime.stringUtils,
          camelCase = _this$runtime$stringU.camelCase,
          snakeCase = _this$runtime$stringU.snakeCase;
      var cased = camelCase(snakeCase(this.name));
      return uniq(["runtime.argv.features.".concat(this.name), "runtime.options.features.".concat(this.name), "runtime.config.features.".concat(this.name), "runtime.argv.features.".concat(cased), "runtime.options.features.".concat(cased), "runtime.argv.".concat(this.name), "runtime.projectConfig.".concat(this.name), "runtime.options.".concat(this.name), "runtime.argv.".concat(cased), "runtime.projectConfig.".concat(cased), "runtime.options.".concat(cased)]);
    }
  }], [{
    key: "createRegistry",

    /**
     * This lets you create feature instances using the `runtime.feature` factory method
     * without first registering the module with the `runtime.features` registry.
     */

    /**
     * Since features are cacheable, you will get the same instance of the feature back
     * every time you call the `runtime.feature` factory method with the same arguments
     *
     * @example
     *
     *  const one = runtime.feature('my-feature')
     *  const two = runtime.feature('my-feature')
     *  const three = runtime.feature('my-feature', { cacheHelper: false })
     *
     *  console.assert(one.uuid === two.uuid)
     *  console.assert(three.uuid !== two.uuid)
     */

    /**
     * Creates a Feature registry.
     *
     * @param {Object} options options for the context registry
     * @param {String} [options.name='features'] the name of the registry
     * @param {Object<String,Function>} [options.features={}] items to populate the registry with
     *
     * @returns {ContextRegistry}
     */
    value: function createRegistry() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var reg = _helper["default"].createContextRegistry(options.name || 'features', (0, _objectSpread2["default"])({
        context: _helper["default"].createMockContext(options.features || {})
      }, options));

      reg.enabled = {};
      return reg;
    }
    /**
     * Attaches this helper class to a runtime.
     *
     * @param {Runtime} runtime the runtime to attach the Feature registry to
     * @param {Object} options options to pass through to `Helper.attach`
     * @param {String} [options.lookupProp='feature'] the name of the factory function to create on the runtime
     * @param {String} [options.registryProp='features'] the name of the registry prop to create on the runtime
     * @returns {Runtime}
     */

  }, {
    key: "attach",
    value: function attach(runtime) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var result = _helper["default"].attach(runtime, Feature, (0, _objectSpread2["default"])({
        registryProp: '_features',
        lookupProp: '_feature',
        cacheHelper: true,
        isCacheable: true,
        registry: Feature.registry
      }, options));

      return result;
    }
  }]);
  return Feature;
}(_helper["default"]);

exports.Feature = Feature;
(0, _defineProperty2["default"])(Feature, "allowAnonymousProviders", false);
(0, _defineProperty2["default"])(Feature, "isCacheable", true);
var _default = Feature;
exports["default"] = _default;
var isCacheable = true;
exports.isCacheable = isCacheable;
var attach = Feature.attach;
exports.attach = attach;
Feature.registry = Feature.createRegistry();
Feature.isSkypagerFeature = true;